<template>
  <v-dialog :value="value" max-width="500" persistent @input="$emit('input', $event)">
    <div class="identity-info-popup">
      <strong class="identity-info-popup__title">계약자 개인정보 변경 요청</strong>
      <div class="identity-info-popup__box">
        <div class="identity-info-popup__field">
          <label>기존 성명</label>
          <input :value="primaryNameValue" type="text" maxlength="50" readonly />
          <p class="identity-info-popup__helper">
            현재 계약서에 등록된 계약자 성명입니다.
          </p>
        </div>

        <div class="identity-info-popup__field">
          <label>기존 주민등록번호</label>
          <div class="identity-info-popup__identity-row">
            <input :value="maskedCurrentIdentityFront" type="text" readonly />
            <span>-</span>
            <input :value="maskedCurrentIdentityBack" type="text" readonly />
          </div>
          <p class="identity-info-popup__helper">
            주민등록번호는 보안상 일부만 표시됩니다.
          </p>
        </div>

        <div class="identity-info-popup__field identity-info-popup__field--spaced">
          <label>변경할 성명</label>
          <input :value="nameChangeValue" type="text" maxlength="50" readonly />
          <p class="identity-info-popup__helper">
            계약자 성명은 실명인증 시 확인된 이름으로만 변경됩니다.
          </p>
          <!-- 이전 변경 요청한 성명 노출이 필요할 경우 사용 -->
          <!-- <p v-if="showRequestedNameHelper" class="identity-info-popup__helper">
            (이전변경요청한 성명: {{ requestedHistoryName }})
          </p> -->
        </div>

        <label class="identity-info-popup__check">
          <input
            v-model="form.changeIdentityNumber"
            type="checkbox"
            :disabled="!isFormEditable || isIdentityNumberRequiredOnModify"
          />
          <span>{{isModifyMode ? "주민등록번호 수정" : "주민등록번호 변경"}}</span>
        </label>

        <div v-if="showIdentityNumberInput" class="identity-info-popup__field">
          <!-- <label>{{ isFormEditable ? "변경할 주민등록번호" : "변경 후 주민등록번호" }}</label> -->
          <label>변경할 주민등록번호</label>
          <div class="identity-info-popup__identity-row">
            <input
              :value="form.identityFront"
              type="text"
              inputmode="numeric"
              maxlength="6"
              placeholder="앞 6자리"
              :readonly="!isFormEditable"
              @input="handleIdentityFrontInput"
              @paste="handleIdentityFrontPaste"
            />
            <span>-</span>
            <input
              :value="maskedIdentityBackInput"
              type="text"
              inputmode="numeric"
              maxlength="7"
              placeholder="뒤 7자리"
              :readonly="!isFormEditable"
              @input="handleIdentityBackInput"
              @paste="handleIdentityBackPaste"
            />
          </div>
          <p class="identity-info-popup__helper">
            주민등록번호는 보안상 일부만 표시됩니다.
          </p>
        </div>

        <div class="identity-info-popup__field">
          <label>변경사유</label>
          <textarea
            v-model.trim="form.remark"
            rows="4"
            maxlength="500"
            placeholder="변경 사유를 입력해주세요."
            :readonly="!isFormEditable"
            :disabled="isModifyReviewMode"
          ></textarea>
        </div>

        <div class="identity-info-popup__field">
          <label>첨부파일</label>
          <div class="identity-info-popup__file-row">
            <button
              type="button"
              class="identity-info-popup__file-name"
              :class="{ 'is-previewable': !!form.file }"
              :disabled="historyFileLoading"
              @click="openFileExternal"
            >
              {{ fileDisplayText }}
            </button>
            <button
              type="button"
              class="identity-info-popup__file-button"
              :disabled="!isFormEditable"
              @click="selectFile"
            >
              파일첨부
            </button>
          </div>
          <input
            ref="fileInput"
            type="file"
            class="identity-info-popup__file-input"
            accept=".pdf,.jpg,.jpeg,.png,.heic,.heif"
            @change="handleFileChange"
          />
          <p class="identity-info-popup__helper">
            PDF, 이미지 형식만 첨부할 수 있으며, 파일 크기는 10MB 이하만 가능합니다.<br>
            인적사항(이름, 주민등록번호) 변경내용 이력이 포함된 초본을 발급하여 첨부하여 주시기 바랍니다.
          </p>
        </div>

        

        <!-- <div class="identity-info-popup__notice">
          <p>※ 요청하신 계약자 개인정보 변경 사항은 우미 린 에서 승인 이후 정보가 수정 됩니다.</p>
          <p>※ 승인된 정보로 내용이 변경 될 시 고객님께 따로 안내를 드리기 전까지 다시 요청 하실 수 없습니다.</p>
        </div> -->
      </div>
      <div>

        <div class="identity-info-popup__field one-line" style="margin-bottom: 0px; margin-left: 20px;" @click="agreeDialog = !agreeDialog">
          <v-checkbox v-model="agreeCheck" readonly label="" class="mr-0 pa-0" /> <span
            class="agree-check-text mb-1">유의사항 확인 및 동의 (필수)</span>

          <v-dialog v-model="agreeDialog" max-width="460" content-class="postcode-dialog">
            <div class="postcode-embed-popup">
              <div class="postcode-embed-popup__header">
                <strong> ※ 계약자 개인정보 변경 유의사항(성명, 주민등록번호)</strong>
              </div>
              <div class="pa-4" v-html="agreeText"
                style="text-align: left; font-size: 13px; font-weight: 400; line-height: 1.6;">
              </div>

              <v-divider></v-divider>

              <div class="d-flex justify-end">
                <v-btn color="grey" class="mr-2" text @click="agreeCheck = false; agreeDialog = false;">닫 기</v-btn>
                <v-btn color="primary" class="ml-2 mr-2" text
                  @click="agreeCheck = true; agreeDialog = false;">동의합니다</v-btn>
              </div>
            </div>
          </v-dialog>

        </div>
      
      <div class="identity-info-popup__footer">
        <button
          type="button"
          class="identity-info-popup__button is-close"
          @click="handleBackButton"
        >
          {{ backButtonText }}
        </button>
        <button
          v-if="isModifyReviewMode"
          type="button"
          class="identity-info-popup__button is-submit"
          :disabled="loading"
          @click="startEditExistingRequest"
        >
          변경요청 수정
        </button>
        <button
          v-else
          type="button"
          class="identity-info-popup__button is-submit"
          :disabled="!isFormReady || loading"
          @click="submit"
        >
          {{ submitButtonText }}
        </button>
      </div>
      </div>
    </div>

    <div v-if="loading" class="identity-info-loading-layer">
      <div class="identity-info-loading-dialog">
        <v-progress-circular indeterminate color="#f07a24" size="28"></v-progress-circular>
        <p>변경 중입니다...</p>
      </div>
    </div>

    <div
      v-if="imagePreviewUrl"
      class="identity-info-image-preview"
      @click.self="closeImagePreview()"
    >
      <div class="identity-info-image-preview__dialog">
        <div class="identity-info-image-preview__header">
          <strong>{{ imagePreviewName || "첨부 이미지" }}</strong>
          <div class="identity-info-image-preview__controls">
            <button type="button" @click="closeImagePreview()">닫기</button>
          </div>
        </div>
        <div
          class="identity-info-image-preview__body"
          @pointerdown="startImagePreviewPan"
          @pointermove="moveImagePreviewPan"
          @pointerup="endImagePreviewPan"
          @pointercancel="endImagePreviewPan"
          @pointerleave="endImagePreviewPan"
        >
          <img
            :src="imagePreviewUrl"
            :alt="imagePreviewName || '첨부 이미지'"
            :style="imagePreviewStyle"
            @wheel.prevent="handleImagePreviewWheel"
          />
        </div>
      </div>
    </div>

  </v-dialog>
</template>

<script>
import { getContractorHistoryFile } from "@/api/contract";

const MAX_UPLOAD_FILE_SIZE = 10 * 1024 * 1024;
const ALLOWED_UPLOAD_FILE_EXTENSIONS = ["pdf", "jpg", "jpeg", "png", "heic", "heif"];
const ALLOWED_UPLOAD_FILE_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/heic",
  "image/heif",
];

export default {
  // 이름은 읽기 전용으로 유지하고, 이름 차이 또는 주민등록번호 변경을 요청하는 다이얼로그
  name: "ContractorIdentityInfoChangeDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    contractor: {
      type: Object,
      default: () => ({}),
    },
    contractId: {
      type: [String, Number],
      default: "",
    },
    activeChangeRequest: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      originalForm: {
        name: "",
        identityFront: "",
        identityBackRaw: "",
      },
      form: {
        name: "",
        changeIdentityNumber: false,
        identityFront: "",
        identityBackRaw: "",
        remark: "",
        file: null,
        fileName: "",
      },
      activeHistoryItem: null,
      requestedHistoryName: "",
      editExistingRequest: false,
      historyFileLoading: false,
      historyFileRequestId: 0,
      isExistingHistoryFileLoaded: false,
      imagePreviewUrl: "",
      imagePreviewName: "",
      imagePreviewScale: 1,
      imagePreviewMinScale: 1,
      imagePreviewMaxScale: 3,
      imagePreviewPanX: 0,
      imagePreviewPanY: 0,
      imagePreviewDragStart: null,
      imagePreviewPointers: [],
      imagePreviewPinchStart: null,
      imagePreviewHistoryActive: false,

      agreeCheck: false,
      agreeDialog: false,
      agreeText: `• 회원 정보와 계약자 정보(성명/ 연락처) 불일치 시 계약단지 조회가 불가합니다.<br>
• 요청하신 계약자 정보 변경 사항은 관리자 승인 이후 반영됩니다.<br>
• 정보 변경 신청 후 관리자 심사 완료 전까지 추가 정보 변경 신청은 불가합니다.<br>
• 변경된 정보 확인을 위해 주민등록초본을 첨부하여 주시기 바랍니다.<br>
• 계약서 수정이 필요한 경우, 분양사무실로 연락하여 요청하시기 바랍니다.`
    };
  },
  computed: {
    isModifyMode() {
      return !!this.activeHistoryItem;
    },
    isModifyReviewMode() {
      return this.isModifyMode && !this.editExistingRequest;
    },
    isFormEditable() {
      return !this.isModifyMode || this.editExistingRequest;
    },
    submitButtonText() {
      return this.isModifyMode ? "수정완료" : "변경요청";
    },
    backButtonText() {
      return this.isModifyMode && this.editExistingRequest ? "수정취소" : "뒤로가기";
    },
    primaryNameValue() {
      return this.originalForm.name;
    },
    verifiedUserName() {
      return this.normalizeValue(this.user.name);
    },
    modifyTargetName() {
      if (this.verifiedUserName) {
        return this.verifiedUserName;
      }

      if (this.editExistingRequest) {
        return this.normalizeValue(this.form.name);
      }

      if (this.requestedHistoryName) {
        return this.requestedHistoryName;
      }

      return "";
    },
    showModifyTargetNameField() {
      return (
        this.isModifyMode &&
        !!this.modifyTargetName &&
        this.normalizeValue(this.modifyTargetName) !== this.normalizeValue(this.originalForm.name)
      );
    },
    showNameChangeField() {
      if (this.isModifyMode) {
        return this.showModifyTargetNameField;
      }

      return this.hasNameChanged;
    },
    nameChangeValue() {
      if (this.isModifyMode) {
        return this.modifyTargetName;
      }

      return this.form.name;
    },
    hasNameChanged() {
      return (
        this.normalizeValue(this.form.name) !==
        this.normalizeValue(this.originalForm.name)
      );
    },
    showRequestedNameHelper() {
      return (
        this.isModifyMode &&
        !!this.requestedHistoryName &&
        this.normalizeValue(this.requestedHistoryName) !== this.normalizeValue(this.nameChangeValue)
      );
    },
    isIdentityNumberRequiredOnModify() {
      return (
        this.isModifyMode &&
        !!this.findChangedField(this.activeHistoryItem, "citizen_number")
      );
    },
    showIdentityNumberInput() {
      return this.form.changeIdentityNumber || this.isIdentityNumberRequiredOnModify;
    },
    isFormReady() {
      return !!(
        (this.hasNameChanged || this.showIdentityNumberInput) &&
        (!this.showIdentityNumberInput || (
          this.form.identityFront.length === 6 &&
          this.form.identityBackRaw.length === 7
        )) &&
        this.form.remark &&
        this.form.file &&
        this.agreeCheck
      );
    },
    fileDisplayText() {
      if (this.historyFileLoading) {
        return "첨부파일 불러오는 중...";
      }

      if (this.isExistingHistoryFileLoaded) {
        return this.form.fileName || "첨부파일 열어보기";
      }

      if (this.shouldFetchHistoryFile(this.activeHistoryItem)) {
        return this.form.fileName || "첨부파일 열어보기";
      }

      return this.form.fileName || "첨부파일을 선택해주세요.";
    },
    maskedCurrentIdentityFront() {
      return this.originalForm.identityFront || "";
    },
    maskedCurrentIdentityBack() {
      if (!this.originalForm.identityBackRaw) {
        return "";
      }

      return `${this.originalForm.identityBackRaw[0]}${"*".repeat(6)}`;
    },
    maskedIdentityBackInput() {
      const raw = this.form.identityBackRaw;

      if (!raw) {
        return "";
      }

      if (raw.length <= 1) {
        return raw;
      }

      return `${raw[0]}${"*".repeat(raw.length - 1)}`;
    },
    imagePreviewStyle() {
      return {
        transform: `translate(${this.imagePreviewPanX}px, ${this.imagePreviewPanY}px) scale(${this.imagePreviewScale})`,
      };
    },
  },
  watch: {
    value(val) {
      if (val) {
        // 다이얼로그가 열릴 때마다 표시용 원본 값과 신규 입력값을 초기화한다.
        this.initForm();
      } else {
        this.historyFileRequestId += 1;
        this.historyFileLoading = false;
        this.closeImagePreview(false);
      }
    },
    activeChangeRequest() {
      // 제출 직후 부모가 요청 상태를 재조회하는 동안에는
      // 열린 다이얼로그를 다시 초기화하지 않아야 수정 UI가 흔들리지 않는다.
      if (this.value && !this.loading) {
        this.initForm();
      }
    },
  },
  beforeDestroy() {
    this.closeImagePreview(false);
  },
  methods: {
    initForm() {
      // console.log("contractor: ", this.contractor);
      this.historyFileRequestId += 1;
      const activeHistoryItem = this.activeChangeRequest;
      this.activeHistoryItem = activeHistoryItem;
      this.requestedHistoryName = "";
      this.editExistingRequest = false;
      this.historyFileLoading = false;
      this.isExistingHistoryFileLoaded = false;

      if (activeHistoryItem) {
        this.initFormFromHistory(activeHistoryItem);
        return;
      }

      // 계약서상 이름과 현재 실명인증 이름을 비교할 수 있게 각각 보관한다.
      const { front, back } = this.parseIdentityNumber(this.contractor.citizen_number);
      this.originalForm = {
        name: this.contractor.name || "",
        identityFront: front,
        identityBackRaw: back,
      };
      this.form = {
        name: this.user.name || "",
        changeIdentityNumber: false,
        identityFront: "",
        identityBackRaw: "",
        remark: "",
        file: null,
        fileName: "",
      };
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    initFormFromHistory(historyItem) {
      const nameField = this.findChangedField(historyItem, "name");
      const identityField = this.findChangedField(historyItem, "citizen_number");
      const oldIdentity = this.parseIdentityNumber(identityField?.old || "");
      const newIdentity = this.parseIdentityNumber(identityField?.new || "");
      const existingFileName = this.getHistoryFileName(historyItem);

      const requestedHistoryName = this.normalizeValue(nameField?.new || "");
      const historyName = requestedHistoryName ||  "";
      this.requestedHistoryName = requestedHistoryName;

      this.originalForm = {
        name: this.contractor.name || "",
        identityFront: oldIdentity.front,
        identityBackRaw: oldIdentity.back,
      };
      this.form = {
        name: historyName,
        changeIdentityNumber: !!identityField,
        identityFront: newIdentity.front,
        identityBackRaw: this.getMaskedIdentityBack(newIdentity.back),
        remark: historyItem.change_reason || historyItem.remark || "",
        file: null,
        fileName: existingFileName,
      };

      if (this.shouldFetchHistoryFile(historyItem)) {
        this.fetchHistoryFile(historyItem, existingFileName, this.historyFileRequestId);
      }

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    normalizeHistoryStatus(status) {
      return String(status || "").replace(/\s/g, "");
    },
    shouldFetchHistoryFile(item) {
      return ["요청", "재요청"].includes(
        this.normalizeHistoryStatus(item?.status)
      );
    },
    getChangedFields(item) {
      return Array.isArray(item?.changed_fields) ? item.changed_fields : [];
    },
    findChangedField(item, fieldName) {
      return this.getChangedFields(item).find((field) => field.field === fieldName);
    },
    getHistoryFileName(item) {
      return String(item?.file_name || "").trim();
    },
    fetchHistoryFile(historyItem, fallbackFileName = "", requestId = this.historyFileRequestId) {
      const contractId = this.contractId;
      const historySequence = historyItem?.no_seq;

      if (!contractId || !historySequence) {
        return Promise.resolve(null);
      }

      this.historyFileLoading = true;

      return getContractorHistoryFile(contractId, historySequence)
        .then((response) => {
          if (requestId !== this.historyFileRequestId) {
            return null;
          }

          const blob = response.data;
          const fileName = this.getHistoryFileName(historyItem) || fallbackFileName;
          const fileType = blob?.type || this.getMimeTypeByFileName(fileName);

          this.form.file = new File([blob], fileName, {
            type: fileType || "application/octet-stream",
          });
          this.form.fileName = fileName;
          this.isExistingHistoryFileLoaded = true;

          return this.form.file;
        })
        .catch((error) => {
          if (requestId !== this.historyFileRequestId) {
            return null;
          }

          this.form.file = null;
          this.form.fileName = fallbackFileName || this.form.fileName;
          this.isExistingHistoryFileLoaded = false;
          console.error("Error fetching contractor history file:", error);
          this.$store.commit(
            "ERROR",
            "첨부파일을 불러오지 못했습니다. 잠시 후 다시 시도해주세요."
          );
          return null;
        })
        .finally(() => {
          if (requestId === this.historyFileRequestId) {
            this.historyFileLoading = false;
          }
        });
    },
    getMimeTypeByFileName(fileName) {
      const extension = String(fileName || "").split(".").pop().toLowerCase();
      const extensionMap = {
        pdf: "application/pdf",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
      };

      return extensionMap[extension] || "";
    },
    parseIdentityNumber(value) {
      const digits = String(value || "").replace(/\D/g, "");
      const front = digits.slice(0, 6);
      const back = digits.slice(6, 13);

      return {
        front,
        back,
      };
    },
    normalizeValue(value) {
      return String(value ?? "").trim();
    },
    normalizeIdentityFront(value) {
      return this.normalizeValue(value).replace(/\D/g, "").slice(0, 6);
    },
    normalizeIdentityBack(value) {
      return this.normalizeValue(value).replace(/\D/g, "").slice(0, 7);
    },
    getFullIdentityNumber(front, back) {
      return `${this.normalizeIdentityFront(front)}${this.normalizeIdentityBack(back)}`;
    },
    getMaskedIdentityBack(value) {
      const back = this.normalizeIdentityBack(value);

      if (!back) {
        return "";
      }

      return `${back[0]}${"*".repeat(6)}`;
    },
    startEditExistingRequest() {
      this.editExistingRequest = true;
      if (this.verifiedUserName) {
        this.form.name = this.verifiedUserName;
      }

      if (this.isIdentityNumberRequiredOnModify) {
        this.form.changeIdentityNumber = true;
      }

      if (this.showIdentityNumberInput) {
        this.form.identityFront = "";
        this.form.identityBackRaw = "";
      }
    },
    cancelEditExistingRequest() {
      this.editExistingRequest = false;
      this.initFormFromHistory(this.activeHistoryItem);
    },
    // 신규로 입력한 주민등록번호 13자리와 사유, 첨부파일을 변경 요청 payload로 만든다.
    getChangedPayload() {
      const payload = {
        remark: this.normalizeValue(this.form.remark),
      };

      if (this.form.file) {
        payload.file = this.form.file;
      }

      if (this.hasNameChanged) {
        payload.name = this.normalizeValue(this.form.name);
      }

      if (this.showIdentityNumberInput) {
        payload.citizen_number = this.getFullIdentityNumber(
          this.form.identityFront,
          this.form.identityBackRaw
        );
      }

      if (this.isModifyMode) {
        payload._requestMode = "update";
        if (this.activeHistoryItem?.no_seq != null) {
          payload.no_seq = this.activeHistoryItem.no_seq;
        }
      }

      return payload;
    },
    handleIdentityFrontInput(event) {
      if (!this.isFormEditable) {
        return;
      }

      this.form.identityFront = String(event.target.value || "")
        .replace(/\D/g, "")
        .slice(0, 6);
    },
    handleIdentityFrontPaste(event) {
      event.preventDefault();
      if (!this.isFormEditable) {
        return;
      }

      const pastedText = event.clipboardData?.getData("text") || "";
      this.form.identityFront = pastedText.replace(/\D/g, "").slice(0, 6);
    },
    handleIdentityBackInput(event) {
      if (!this.isFormEditable) {
        return;
      }

      // 화면에는 마스킹된 값이 표시되므로, 이전 길이 대비 늘어나거나 줄어든 만큼만
      // 실제 원본 값에 반영해 마스킹 문자가 실제 입력값을 훼손하지 않도록 한다.
      const previousRaw = this.form.identityBackRaw;
      const inputValue = String(event.target.value || "");

      if (inputValue.length > previousRaw.length) {
        const addedDigits = inputValue
          .slice(previousRaw.length)
          .replace(/\D/g, "");
        this.form.identityBackRaw = `${previousRaw}${addedDigits}`.slice(0, 7);
      } else {
        this.form.identityBackRaw = previousRaw.slice(0, inputValue.length);
      }
    },
    handleIdentityBackPaste(event) {
      event.preventDefault();
      if (!this.isFormEditable) {
        return;
      }

      const pastedText = event.clipboardData?.getData("text") || "";
      this.form.identityBackRaw = pastedText.replace(/\D/g, "").slice(0, 7);
    },
    selectFile() {
      if (!this.isFormEditable) {
        return;
      }

      this.$refs.fileInput?.click();
    },
    handleFileChange(event) {
      const [file] = event.target.files || [];

      if (!file) {
        return;
      }

      const validationError = this.validateUploadFile(file);

      if (validationError) {
        event.target.value = "";
        this.$store.commit("ERROR", validationError);
        return;
      }

      // 업로드 요청에 그대로 사용할 File 객체와 표시용 파일명을 함께 보관한다.
      this.closeImagePreview(false);
      this.historyFileRequestId += 1;
      this.historyFileLoading = false;
      this.isExistingHistoryFileLoaded = false;
      this.form.file = file || null;
      this.form.fileName = file ? file.name : "";
    },
    validateUploadFile(file) {
      const fileName = String(file?.name || "");
      const fileExtension = fileName.includes(".")
        ? fileName.split(".").pop().toLowerCase()
        : "";
      const fileType = String(file?.type || "").toLowerCase();

      if (!ALLOWED_UPLOAD_FILE_EXTENSIONS.includes(fileExtension)) {
        return "첨부파일은 PDF, 이미지 형식만 업로드할 수 있습니다.";
      }

      if (fileType && !ALLOWED_UPLOAD_FILE_TYPES.includes(fileType)) {
        return "첨부파일은 PDF, 이미지 형식만 업로드할 수 있습니다.";
      }

      if (Number(file?.size || 0) > MAX_UPLOAD_FILE_SIZE) {
        return "첨부파일은 10MB 이하만 업로드할 수 있습니다.";
      }

      return "";
    },
    openFileExternal() {
      if (this.historyFileLoading) {
        return;
      }

      if (!this.form.file) {
        if (this.form.fileName) {
          this.$store.commit("ERROR", "첨부파일 데이터를 불러오지 못했습니다.");
        }
        return;
      }
      console.log("this.form.file: ", this.form.file);
      if (this.isImageFile(this.form.file)) {
        this.openImagePreview(this.form.file);
        return;
      }

      this.openFileInNewWindow(this.form.file);
    },
    isImageFile(file) {
      const fileType = String(file?.type || "").toLowerCase();
      const fileName = String(this.form.fileName || file?.name || "").toLowerCase();

      return (
        fileType.startsWith("image/") ||
        /\.(jpg|jpeg|png)$/.test(fileName)
      );
    },
    openImagePreview(file) {
      if (typeof URL === "undefined" || !URL.createObjectURL) {
        this.$store.commit("ERROR", "첨부파일을 열 수 없습니다.");
        return;
      }

      this.closeImagePreview(false);
      this.imagePreviewUrl = URL.createObjectURL(file);
      this.imagePreviewName = this.form.fileName || file.name || "첨부 이미지";
      this.imagePreviewScale = 1;
      this.resetImagePreviewPan();
      this.enableImagePreviewBackGuard();
    },
    closeImagePreview(syncHistory = true) {
      if (this.imagePreviewUrl && typeof URL !== "undefined" && URL.revokeObjectURL) {
        URL.revokeObjectURL(this.imagePreviewUrl);
      }

      this.imagePreviewUrl = "";
      this.imagePreviewName = "";
      this.imagePreviewScale = 1;
      this.resetImagePreviewPan();
      this.disableImagePreviewBackGuard(syncHistory);
    },
    enableImagePreviewBackGuard() {
      if (
        this.imagePreviewHistoryActive ||
        typeof window === "undefined" ||
        !window.history?.pushState
      ) {
        return;
      }

      window.history.pushState(
        { contractorIdentityImagePreview: true },
        "",
        this.$route?.fullPath || window.location.href
      );
      window.addEventListener("popstate", this.handleImagePreviewBackNavigation);
      this.imagePreviewHistoryActive = true;
    },
    disableImagePreviewBackGuard(syncHistory = true) {
      if (
        !this.imagePreviewHistoryActive ||
        typeof window === "undefined"
      ) {
        return;
      }

      window.removeEventListener("popstate", this.handleImagePreviewBackNavigation);
      this.imagePreviewHistoryActive = false;

      if (syncHistory && window.history?.back) {
        window.history.back();
      }
    },
    handleImagePreviewBackNavigation() {
      if (!this.imagePreviewHistoryActive) {
        return;
      }

      this.closeImagePreview(false);
    },
    handleImagePreviewWheel(event) {
      const nextScale = this.imagePreviewScale + (event.deltaY < 0 ? 0.25 : -0.25);
      this.setImagePreviewScale(nextScale);
    },
    setImagePreviewScale(scale) {
      const normalizedScale = Math.min(
        this.imagePreviewMaxScale,
        Math.max(this.imagePreviewMinScale, scale)
      );

      this.imagePreviewScale = Number(normalizedScale.toFixed(2));

      if (this.imagePreviewScale <= this.imagePreviewMinScale) {
        this.resetImagePreviewPan();
      }
    },
    resetImagePreviewPan() {
      this.imagePreviewPanX = 0;
      this.imagePreviewPanY = 0;
      this.imagePreviewDragStart = null;
      this.imagePreviewPointers = [];
      this.imagePreviewPinchStart = null;
    },
    startImagePreviewPan(event) {
      event.preventDefault();
      this.updateImagePreviewPointer(event);
      event.currentTarget.setPointerCapture?.(event.pointerId);

      if (this.imagePreviewPointers.length >= 2) {
        this.startImagePreviewPinch();
        return;
      }

      this.startImagePreviewDrag(event);
    },
    moveImagePreviewPan(event) {
      this.updateImagePreviewPointer(event);

      if (this.imagePreviewPointers.length >= 2 && this.imagePreviewPinchStart) {
        const distance = this.getImagePreviewPointerDistance();

        if (distance > 0) {
          this.setImagePreviewScale(
            this.imagePreviewPinchStart.scale *
            distance / this.imagePreviewPinchStart.distance
          );
        }
        return;
      }

      if (
        !this.imagePreviewDragStart ||
        this.imagePreviewScale <= this.imagePreviewMinScale
      ) {
        return;
      }

      this.imagePreviewPanX = this.imagePreviewDragStart.panX +
        event.clientX - this.imagePreviewDragStart.startX;
      this.imagePreviewPanY = this.imagePreviewDragStart.panY +
        event.clientY - this.imagePreviewDragStart.startY;
    },
    endImagePreviewPan(event) {
      if (this.imagePreviewDragStart?.pointerId === event.pointerId) {
        event.currentTarget.releasePointerCapture?.(event.pointerId);
      }

      this.removeImagePreviewPointer(event.pointerId);
      this.imagePreviewDragStart = null;
      this.imagePreviewPinchStart = null;

      if (
        this.imagePreviewPointers.length === 1 &&
        this.imagePreviewScale > this.imagePreviewMinScale
      ) {
        const [pointer] = this.imagePreviewPointers;
        this.imagePreviewDragStart = {
          pointerId: pointer.pointerId,
          startX: pointer.clientX,
          startY: pointer.clientY,
          panX: this.imagePreviewPanX,
          panY: this.imagePreviewPanY,
        };
      }
    },
    startImagePreviewDrag(event) {
      if (this.imagePreviewScale <= this.imagePreviewMinScale) {
        this.imagePreviewDragStart = null;
        return;
      }

      this.imagePreviewDragStart = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        panX: this.imagePreviewPanX,
        panY: this.imagePreviewPanY,
      };
    },
    startImagePreviewPinch() {
      const distance = this.getImagePreviewPointerDistance();

      if (distance <= 0) {
        return;
      }

      this.imagePreviewDragStart = null;
      this.imagePreviewPinchStart = {
        distance,
        scale: this.imagePreviewScale,
      };
    },
    updateImagePreviewPointer(event) {
      const pointer = {
        pointerId: event.pointerId,
        clientX: event.clientX,
        clientY: event.clientY,
      };
      const index = this.imagePreviewPointers.findIndex(
        (item) => item.pointerId === pointer.pointerId
      );

      if (index >= 0) {
        this.imagePreviewPointers.splice(index, 1, pointer);
      } else {
        this.imagePreviewPointers.push(pointer);
      }
    },
    removeImagePreviewPointer(pointerId) {
      this.imagePreviewPointers = this.imagePreviewPointers.filter(
        (pointer) => pointer.pointerId !== pointerId
      );
    },
    getImagePreviewPointerDistance() {
      if (this.imagePreviewPointers.length < 2) {
        return 0;
      }

      const [firstPointer, secondPointer] = this.imagePreviewPointers;
      return Math.hypot(
        secondPointer.clientX - firstPointer.clientX,
        secondPointer.clientY - firstPointer.clientY
      );
    },
    openFileInNewWindow(file) {
      if (typeof URL === "undefined" || !URL.createObjectURL) {
        this.$store.commit("ERROR", "첨부파일을 열 수 없습니다.");
        return;
      }

      const fileUrl = URL.createObjectURL(file);
      const popup = window.open(fileUrl, "_blank");

      if (!popup) {
        this.$store.commit("ERROR", "첨부파일 창을 열 수 없습니다.");
      } else {
        popup.opener = null;
      }

      window.setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 60000);
    },
    close() {
      this.$emit("input", false);
    },
    goBack() {
      this.$emit("back");
    },
    handleBackButton() {
      if (this.isModifyMode && this.editExistingRequest) {
        this.cancelEditExistingRequest();
        return;
      }

      this.goBack();
    },
    submit() {
      const payload = this.getChangedPayload();

      if (this.showIdentityNumberInput && (!payload.citizen_number || payload.citizen_number.length !== 13)) {
        this.$store.commit("ERROR", "주민등록번호 13자리를 모두 입력해주세요.");
        return;
      }

      if (!this.hasNameChanged && !this.showIdentityNumberInput) {
        this.$store.commit(
          "ERROR",
          "변경된 정보가 없습니다."
        );
        return;
      }

      this.$emit("submit", payload);
    },
  },
};
</script>

<style scoped>
.identity-info-popup {
  border-radius: 20px;
  background-color: #ffffff;
  text-align: left;
}

.identity-info-popup__title {
  display: block;
  text-align: center;
  color: #e66a1f;
  font-size: 24px;
  padding: 24px 24px 12px;
  font-weight: 700;
}

.identity-info-popup__box {
  padding: 12px 24px;
  max-height:600px; overflow-y:auto;
}

.identity-info-popup__field {
  margin-bottom: 16px;
}

.identity-info-popup__field--spaced {
  margin-top: 12px;
}

.identity-info-popup__field label {
  display: block;
  margin-bottom: 8px;
  color: #b4b4b4;
  font-size: 15px;
  font-weight: 700;
}

.identity-info-popup__field input:not([type="checkbox"]),
.identity-info-popup__field textarea {
  width: 100%;
  border: 1px solid #222222;
  border-radius: 0;
  padding: 10px 12px;
  color: #222222;
  font-size: 14px;
  background-color: #ffffff;
  border-radius:6px;
}

.identity-info-popup__field input[readonly]:not([type="checkbox"]),
.identity-info-popup__field textarea[readonly],
.identity-info-popup__field textarea:disabled {
  color: #222222;
  background-color: #f7f7f7;
  opacity: 1;
}

.identity-info-popup__field textarea {
  min-height: 96px;
  resize: none;
}

.identity-info-popup__helper {
  margin: 8px 0 0;
  color: #767676;
  font-size: 13px;
  line-height: 1.45;
  word-break: keep-all;
}

.identity-info-popup__check {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 16px;
  color: #222222;
  font-size: 14px;
  font-weight: 700;
}

.identity-info-popup__check input {
  appearance: auto;
  -webkit-appearance: checkbox;
  -moz-appearance: checkbox;
  accent-color: #f07a24;
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  margin: 0;
  opacity: 1;
  visibility: visible;
  position: static;
  pointer-events: auto;
}

.identity-info-popup__check span {
  line-height: 1.4;
}

.identity-info-popup__identity-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.identity-info-popup__identity-row span {
  color: #222222;
  font-size: 20px;
  font-weight: 700;
}

.identity-info-popup__identity-row input {
  flex: 1 1 0;
}

.identity-info-popup__identity-row input:first-child {
  letter-spacing: 0.02em;
}

.identity-info-popup__file-row {
  display: flex;
  gap: 8px;
}

.identity-info-popup__file-name {
  flex: 1 1 auto;
  min-width: 0;
  border: 1px solid #222222;
  border-radius: 0;
  padding: 10px 12px;
  color: #222222;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: #f7f7f7;
  border-radius: 6px;
}

.identity-info-popup__file-name.is-previewable {
  cursor: pointer;
  text-decoration: underline;
}

.identity-info-popup__file-button {
  min-width: 130px;
  border: 0;
  background-color: #000000;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 6px;
}

.identity-info-popup__file-input {
  display: none;
}

.identity-info-popup__notice {
  margin: 2px 0 22px;
}

.identity-info-popup__notice p {
  margin: 0 0 6px;
  color: #f07a24;
  font-size: 13px;
  line-height: 1.45;
  word-break: keep-all;
}

.identity-info-popup__notice p:last-child {
  margin-bottom: 0;
}

.identity-info-popup__footer {
  padding:12px 24px 24px;
  display: flex;
  gap: 12px;
}

.identity-info-popup__button {
  height: 48px;
  border: 0;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
}

.identity-info-popup__button.is-close {
  flex: 0 0 110px;
  background-color: #d9d9d9;
  color: #222222;
}

.identity-info-popup__button.is-submit {
  flex: 1 1 auto;
  background-color: #f07a24;
  color: #ffffff;
}

.identity-info-popup__button.is-submit:disabled {
  opacity: 0.45;
}

.identity-info-loading-layer {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.identity-info-loading-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 28px 20px;
  border-radius: 18px;
  background-color: #ffffff;
}

.identity-info-loading-dialog p {
  margin: 0;
  color: #444444;
  font-size: 14px;
  font-weight: 700;
}

.identity-info-image-preview {
  position: fixed;
  inset: 0;
  z-index: 3100;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000000;
}

.identity-info-image-preview__dialog {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #000000;
}

.identity-info-image-preview__header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: calc(env(safe-area-inset-top, 0px) + 12px) 14px 12px;
  background-color: rgba(0, 0, 0, 0.82);
}

.identity-info-image-preview__header strong {
  flex: 1 1 auto;
  min-width: 0;
  color: #ffffff;
  font-size: 15px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.identity-info-image-preview__controls {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.identity-info-image-preview__controls span {
  min-width: 44px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}

.identity-info-image-preview__controls button {
  flex: 0 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 999px;
  padding: 7px 12px;
  background-color: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
}

.identity-info-image-preview__controls button:disabled {
  opacity: 0.38;
}

.identity-info-image-preview__body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #000000;
  cursor: grab;
  touch-action: none;
  user-select: none;
}

.identity-info-image-preview img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transform-origin: center center;
  transition: transform 0.16s ease;
  background-color: #000000;
}

@media (max-width: 420px) {
  .identity-info-image-preview__header {
    flex-wrap: wrap;
  }

  .identity-info-image-preview__controls {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 359px) {
  .identity-info-popup {
    padding: 24px 18px 20px;
  }

  .identity-info-popup__file-row,
  .identity-info-popup__footer,
  .identity-info-popup__identity-row {
    flex-direction: column;
    align-items: stretch;
  }

  .identity-info-popup__identity-row span {
    text-align: center;
  }

  .identity-info-popup__button.is-close {
    flex-basis: auto;
  }
}

.one-line {
  display: flex;
  align-items: center;
  gap: 0px;
  cursor: pointer;
}

.agree-check-text {
  font-size: 14px;
  text-decoration: underline;
  text-align: center;
}

.postcode-embed-popup {
  overflow: hidden;
  border-radius: 18px;
  background-color: #ffffff;
}

.postcode-embed-popup__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ececec;
}

.postcode-embed-popup__header strong {
  color: #232323;
  font-size: 16px;
  font-weight: 700;
}

.postcode-embed-popup__close {
  border: 0;
  background: transparent;
  color: #666666;
  font-size: 14px;
  font-weight: 700;
}

.postcode-embed-popup__body {
  width: 100%;
  height: 420px;
}
</style>
